import { useLocation } from "react-router-dom";

export const useLocationId = () => {
  let location = useLocation();
  let arr = location.pathname.split("/");
  return arr[arr.length - 1];
};
